import { Suspense } from 'react'
import { FormattedMessage } from 'react-intl'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import Loader from '@components/Loader/Loader'
import CompanyList from './CompanyList'

import './Home.css'

export default function Home() {
  return (
    <div id="home" className="page">
      <div className="container">
        <h1>
          <FormattedMessage id="home.title" />
        </h1>
        <section className="companies-grid">
          <ErrorBoundary errorComponent={ErrorMessage}>
            <Suspense fallback={<Loader />}>
              <CompanyList />
            </Suspense>
          </ErrorBoundary>
        </section>
      </div>
    </div>
  )
}
